import { typedNoPayloadEndpoint, typedPayloadEndpoint, typedPayloadProgressObserverEndpoint, } from "@openpeepshq/fetch-client";
export const allpeepPayloadEndpoint = (rawClient, path, method = "post", convertToFormData) => typedPayloadEndpoint({
    path,
    method,
    convertToFormData,
}, rawClient);
export const allpeepPayloadProgressObserverEndpoint = (rawClient, path, method = "post", convertToFormData) => typedPayloadProgressObserverEndpoint({
    path,
    method,
    convertToFormData,
}, rawClient);
export const allpeepNoPayloadEndpoint = (rawClient, path, method = "get") => typedNoPayloadEndpoint({
    path,
    method,
}, rawClient);
